export default __webpack_public_path__ + "icons/whaleEmpty-834c8c.svg";